import { Rates } from '../../../services';

const DELETING_ALL_RATES         = `pixoo/rates/DELETING_ALL_RATES`;
const DELETING_ALL_RATES_SUCCESS = `pixoo/rates/DELETING_ALL_RATES_SUCCESS`;
const DELETING_ALL_RATES_FAILURE = `pixoo/rates/DELETING_ALL_RATES_FAILURE`;

const deleteAllRatesReducer = (state, action) => {
    switch (action.type) {
        case DELETING_ALL_RATES:
            return {
                ...state,
                isDeletingAllRates: true,
                hasDeleteAllRatesError: false,
            };
        case DELETING_ALL_RATES_SUCCESS:
            return {
                ...state,
                isDeletingAllRates: false,
                hasDeleteAllRatesError: false,
            };
        case DELETING_ALL_RATES_FAILURE:
            return {
                ...state,
                isDeletingAllRates: false,
                hasDeleteAllRatesError: true,
                deleteAllRatesErrorMessage: action.error.message,
            };
        default:
            return state;
    }
};

function deletingAllRates() { return { type: DELETING_ALL_RATES }; }
function deletingAllRatesSuccess() { return { type: DELETING_ALL_RATES_SUCCESS }; }
function deletingAllRatesFailure(err) { return { type: DELETING_ALL_RATES_FAILURE, error: err }; }

const deleteAllRatesAction = (accountId) => {
    return (dispatch) => {
        dispatch(deletingAllRates());
        return Rates.deleteAllRates(accountId)
            .then(() => dispatch(deletingAllRatesSuccess()))
            .catch(err => {
                dispatch(deletingAllRatesFailure(err));
                return Promise.reject(err);
            });
    };
};

export default { deleteAllRatesReducer, deleteAllRatesAction };
